(() => {
  'use strict';

  if (window.__wbPhase3Analytics) return;
  const config = document.currentScript?.dataset;
  if (!config?.contentGroup || window.Shopify?.designMode) return;
  window.__wbPhase3Analytics = true;

  const normalize = value => String(value || '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim();
  const text = element => normalize(element?.textContent);
  const label = element => text(element) || normalize(element?.getAttribute('aria-label'));
  const subscriptionOption = '[data-loop-widget-purchase-option][data-loop-widget-selling-plan-group]';
  const home = config.contentGroup === 'index';
  const pendingVideos = new WeakSet();

  function push(event, parameter1, parameter2, extra = {}) {
    // Clear shared GTM variables so a previous event cannot supply stale parameters.
    (window.dataLayer = window.dataLayer || []).push({
      event,
      content_group: config.contentGroup,
      parameter1,
      parameter2,
      parameter3: undefined,
      video_id: undefined,
      ...extra
    });
  }

  function sectionName(element) {
    if (element.closest('#shopify-section-announcement-bar, #shopify-section-top-bar, [id^="mig-mann-"]')) return 'top_bar';
    if (element.closest('.mig-sat-bar')) return 'sticky_mobile';
    if (element.closest('#t4s-footer')) return 'footer';
    if (element.closest('#shopify-section-header-inline, #mig-menu, header')) return 'header';
    const section = element.closest('[id^="shopify-section-"], [data-section-id]');
    return text(section?.querySelector('h2, h1')) || section?.id || 'section';
  }

  function productName(element) {
    return normalize(element.closest('[data-analytics-product-title], [data-product-title]')?.getAttribute('data-analytics-product-title'))
      || normalize(element.closest('[data-product-title]')?.getAttribute('data-product-title'))
      || normalize(config.productTitle);
  }

  function linkURL(link) {
    try { return new URL(link.href, location.href); } catch { return null; }
  }

  function subscriptionClick(element) {
    const sticky = element.closest('.mig-sat-sub');
    if (sticky) {
      // When already subscribed this button only scrolls to the frequency selector.
      if (/^suscr/i.test(label(sticky))) push('cta_to_suscription', label(sticky), 'sticky_mobile');
      return;
    }
    const option = element.closest(subscriptionOption);
    if (option && !option.matches('.loop-widget-purchase-option-selected, [aria-checked="true"]')
      && !element.closest('a, select, option, button')) {
      push('cta_to_suscription', text(option.querySelector('.loop-widget-purchase-option-label')), sectionName(option));
    }
  }

  document.addEventListener('click', event => {
    const element = event.target instanceof Element ? event.target : event.target?.parentElement;
    // Ignore forwarded .click() calls, such as sticky subscription -> Loop option.
    if (!event.isTrusted || !element || element.closest('[disabled], [aria-disabled="true"]')) return;
    const link = element.closest('a[href]');
    const url = link && linkURL(link);

    if (url?.hostname === 'chat.whatsapp.com') {
      push('cta_to_club_whatsapp', label(link));
    } else if (url && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) {
      push('whatsapp', 'abrir');
    }
    if (element.closest('[data-whatsapp-close]')) push('whatsapp', 'cerrar');

    if (url && [location.hostname, 'wildbalance.es', 'www.wildbalance.es', 'wildbalancemascotas.myshopify.com'].includes(url.hostname)
      && /(?:^|\/)pages\/suscripcion\/?$/.test(url.pathname)) {
      push('cta_to_suscription', label(link), sectionName(link));
    } else {
      subscriptionClick(element);
    }

    const cartTrigger = element.closest('[data-drawer-options]');
    if (cartTrigger) {
      try {
        if (JSON.parse(cartTrigger.getAttribute('data-drawer-options')).id === '#t4s-mini_cart') push('view_cart_foldout');
      } catch { /* Other apps may use this attribute with a different format. */ }
    }

    if (home) {
      const cardCta = element.closest('.mig-fc-back-cta');
      if (cardCta) push('click_carts_category_home', text(cardCta.closest('[data-mig-fc-card]')?.querySelector('.mig-fc-card-label')), label(cardCta));
      const tab = element.closest('[data-mig-fc-tab], [data-mig-bs-tab]');
      if (tab) push('animal_type_selector', normalize(tab.dataset.target), sectionName(tab));
      const all = element.closest('.mig-bs-cta');
      if (all && window.matchMedia('(max-width: 1023px)').matches) {
        const active = all.closest('[id^="mig-bs-"]')?.querySelector('[data-mig-bs-tab].is-active');
        push('see_all', normalize(active?.dataset.target), sectionName(all));
      }
    }

    const subcategory = element.closest('[data-analytics-subcategory]');
    if (subcategory) push('select_subcategory', normalize(config.collectionTitle), normalize(subcategory.dataset.analyticsSubcategory));

    const swatch = element.closest('.t4s-swatch-wrapper [data-swatch-item]');
    if (swatch && !swatch.matches('.is--soldout, .is--unavailable')) {
      const value = normalize(swatch.dataset.value);
      const weight = value.match(/^(\d+(?:[.,]\d+)?)\s*(?:kg|gr?|ml|l)$/i);
      push('select_quantity', productName(swatch), weight ? weight[1].replace(',', '.') : value);
    }

    const info = element.closest('.t4s-product-tabs-wrapper [data-accordion-trigger], .t4s-product-tabs-wrapper .t4s-tab-title');
    const faq = element.closest('.faq-button');
    if (info || (faq && (home || config.contentGroup === 'product'))) {
      const trigger = info || faq;
      push('product_info_drop_down', productName(trigger), label(trigger));
    }

    const footerLink = element.closest('#t4s-footer a');
    if (footerLink) {
      const dropdown = footerLink.closest('.mig-footer-menu-dropdown');
      const column = footerLink.closest('.t4s-col-item');
      const group = text(dropdown?.querySelector('.mig-fmd-toggle')) || text(column?.querySelector('.t4s-col-heading')) || 'footer';
      push('footer', group, label(footerLink));
    }

    const fullReview = element.closest('.jdgm-rev__read-full, .jdgm-rev__read-more');
    const allReviews = element.closest('.jdgm-row-readmore a, .jdgm-all-reviews-text a');
    const writeReview = element.closest('.jdgm-write-rev-link');
    const badge = element.closest('.jdgm-preview-badge');
    if (fullReview) push('review_show_complete', productName(fullReview));
    else if (allReviews) push('review_read_all', productName(allReviews));
    else if (writeReview) push('write_review', productName(writeReview));
    else if (badge && config.contentGroup === 'product' && !badge.closest('.t4s-product, .mig-bs-card, .t4s-product-recommendations')) {
      push('review_pdp_displayed', productName(badge));
    }

    const videoWrap = element.closest('.mig-ugc2-video-wrap');
    const video = videoWrap?.querySelector('video');
    if (video?.paused) pendingVideos.add(video);
  }, true);

  document.addEventListener('keydown', event => {
    if (!event.isTrusted || event.repeat || !['Enter', ' '].includes(event.key)) return;
    const element = event.target;
    // Loop uses ARIA radios, which do not generate native keyboard click events.
    if (element instanceof Element && element.matches(subscriptionOption)) subscriptionClick(element);
  }, true);

  document.addEventListener('pointerover', event => {
    if (!home || !event.isTrusted || event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
    const card = event.target.closest?.('[data-mig-fc-card]');
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    push('hover_carts_category_home', text(card.querySelector('.mig-fc-card-label')));
  }, { capture: true, passive: true });

  document.addEventListener('playing', event => {
    const video = event.target;
    if (!pendingVideos.has(video)) return;
    pendingVideos.delete(video);
    push('play_video', sectionName(video), normalize(video.dataset.analyticsInfluencer) || 'sin_identificar', {
      video_id: normalize(video.dataset.analyticsVideoId)
    });
  }, true);
  for (const name of ['pause', 'ended', 'error', 'emptied']) {
    document.addEventListener(name, event => pendingVideos.delete(event.target), true);
  }
})();
